export const environment = {
  production: false,
  apiVersion: '0.1.0',
  subscriptionKey: 'b5d1e35922a145b0acc7b4742dddbab9',
  trace: 'false',
  pixelMeta: '712880744130635',
  baseApimUrl: 'https://apim-premierpet-development.azure-api.net/premiervet',
  baseBlobUrl:
    'https://safuncpremiervetappdev.blob.core.windows.net/prescricao',
  apiCalculator: 'https://apim-premierpet-development.azure-api.net/calculator',
  // apis-end
  urlPartnerProgram:
    'https://www.premierpet.com.br/veterinarios/parceiro-premiervet/',
  urlLoyaltyProgram: 'https://bemmais.premiervet.com.br/',
  urlPvet: 'https://dev.premiervet.com.br/',
  urlLp: 'https://app-landingpage-prd-dev.azurewebsites.net/ ',
  limiteArquivoClinica: 1000000,
  hotjarConfig: {
    siteId: 0,
    version: 6
  },
  domain: '.premiervet.com.br',
  urlBlog: 'https://premiervet.com.br/blogvet/',
  lumisCmsBlogUrl: 'https://premiervet.com.br/blogvet/',
  urlTermsPdf:
    'https://sapremiervetprd01.blob.core.windows.net/public-files/PremierVet_Termo_e_Poli%CC%81ticas.pdf',
  insights: {
    instrumentationKey: 'aed2dfc9-3c0c-4c10-8d91-c9d770571f39'
  },
  redirectUniversity:
    'https://www.premierpet.com.br/universitarios/premios-de-pesquisa/9o-premio/',
  urlwhereBuyPremier: 'https://www.premierpet.com.br/onde-comprar/',
  urlPremierPetDogs: 'https://www.premierpet.com.br/caes/',
  urlPremierPetCats: 'https://www.premierpet.com.br/gatos/',
  urlInstagram: 'https://www.instagram.com/premiervet/',
  urlYoutube: 'https://www.youtube.com/@PremieRpetOficial',
  urlPlayStore:
    'https://play.google.com/store/apps/details?id=br.com.premiervet',
  urlCanalDenuncia: 'https://contatoseguro.com.br/premierpet',
  urlPoliticaPrivacidade: 'https://premiervet.com.br/termos-de-uso/ ',
  urlTermosDeUso: 'https://premiervet.com.br/termos-de-uso/',
  urlArtigos: 'https://premiervet.com.br/artigos/',
  firebase: {
    apiKey: 'AIzaSyDKp_wM0GGXlKSJc9AdtKCzDMkOJE84uPo',
    authDomain: 'premiervet-a642b.firebaseapp.com',
    projectId: 'premiervet-a642b',
    storageBucket: 'premiervet-a642b.appspot.com',
    messagingSenderId: '583439329050',
    appId: '1:583439329050:web:a8ffe1829337724b39eea3',
    measurementId: 'G-0LQBW9PP8N',
    vapidKey:
      'BBJyMRkaGrJyr-ws-raioRKJCp8I_QFPL9T4KXSGQyF0gUOPTbz7fqibj0lzLSlg8DMPCSR9irMMGS2_h_U5K-E'
  },
  urlContactSpecialistForm:
    'https://forms.office.com/Pages/ResponsePage.aspx?id=DNmG7d4dUk2VR8MOMRK0YdxOVt_wJ-hBsSTGl40I4P9UM1cwNkhCNkJZNUpIRDU1SjlHQzBEMEtKOS4u&embed=true',
  chatbotToken: '3998aacf32d5f802b9f8c02384302092',
  urlChatbotSdk: 'https://webchat.hyperflow.global/sdk.js',
  desloggedAreaChatbotToken: 'c60f21cb4ea3937a8195737f66cc327c',
  tenant: 'ed86d90c-1dde-4d52-9547-c30e3112b461',
  clientId: '3b669b7a-9b2f-45bb-b648-49a68bbe60a3',
  redirectUri: `${window.location.origin}/admin/pagina-inicial`,
  postLogoutRedirectUri: `${window.location.origin}/admin/login`
};
